import React, {useEffect} from 'react'
import Header from '../component/Header'  
import ProductDetailsComp from '../component/ProductDetailsComp'  
import ProductInformation from '../component/ProductInformation' 
// import MedicineHealthProducts from '../component/MedicineHealthProducts' 
// import OfferSection from '../component/OfferSection' 
// import PowerNature from '../component/PowerNature' 
// import Testimonials from '../component/Testimonials' 
// import OurBlogArticle from '../component/OurBlogArticle' 
import ATC from '../component/ATC' 
import ProductDetailsSkeleton from '../component/skeleton/ProductDetailsSkeleton';
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { clearMessages, fetchProductDetail } from "../features/product/productActions";
import {fetchSubscriptionDurations} from "../features/subscription/subscriptionActions";
import { toast } from "react-toastify";
import { Helmet } from 'react-helmet-async';

function ProductDetails() {

   // Get the slug from the URL
   const { slug } = useParams();

   const dispatch = useDispatch();
   const { errorMessage, productRow } = useSelector((state) => state.product);
   console.log("productRow", productRow);
 
   useEffect(() => {
     let data = {slug : slug};
     dispatch(fetchProductDetail(data));
     dispatch(fetchSubscriptionDurations());
   }, [dispatch, slug]);
 
   useEffect(() => {
     if (errorMessage) {
       toast.error(errorMessage, { autoClose: 5000, hideProgressBar: true, className: "toast-error" });
       dispatch(clearMessages()); // Reset the messages after showing the toast
     }
   }, [errorMessage, dispatch]);

  
  return (
    <>
      <Helmet>
        <title>{`Product Details | ${productRow?.title}`}</title>
        <meta name="description" content={productRow?.meta_description} />
        <meta name="keywords" content={productRow?.meta_keywords} />
      </Helmet>

      <div className='main product-details-page'>
        <Header mobileTitle={productRow?.title || "Product Details"}/>
        {(productRow) ? (
          <>
          <ProductDetailsComp productRow={productRow}/>
          <ProductInformation productRow={productRow}/>
          </>
        ) : (
          <ProductDetailsSkeleton></ProductDetailsSkeleton>
        )}
        {/* 
        <MedicineHealthProducts />
        <OfferSection />
        <Testimonials />
        <OurBlogArticle blogTitle="Our Blog & Article" /> */}
        <ATC />
      </div>
    </>
  )
}
export default ProductDetails


